/*

 Input Masks

 */

function mask_init(context) {
    if (typeof Inputmask !== "undefined") {

        if (!$("body").hasClass("inputmask-inited")) {
            Inputmask.extendDefaults({
                showMaskOnHover: false,
                showMaskOnFocus: true,
                onKeyDown: function(event, buffer, caretPos, opts) {
                    if (event && event.target && !$(event.target).inputmask('isComplete')) {
                        $(event.target).removeClass("mask-complete");
                        $(event.target).removeClass("mask-incomplete");
                    }
                },
                oncomplete: function(event) {
                    if (event && event.target) {
                        $(event.target).addClass("mask-complete");
                        $(event.target).removeClass("mask-incomplete");
                    }
                },
                onincomplete: function(event) {
                    if (event && event.target) {
                        $(event.target).removeClass("mask-complete");
                        $(event.target).addClass("mask-incomplete");
                    }
                },
            });

            $("body").addClass("inputmask-inited")
        }

        $(".js-mask-phone-ru", context).filter(":not(.mask-inited)").inputmask({
            definitions: {
                '#': {
                    validator: "[0-9]",
                    cardinality: 1
                }
            },
            mask: "+7 (###) ### ####",
            placeholder: "_",
            onBeforePaste: function (pastedValue, opts) {
                var processedValue = pastedValue;
                processedValue = processedValue.replace(/^8/, '+7');
                return processedValue;
            }
        }).on("keyup", function(event) {
            delay(function(){
                var $this = $(event.target);
                var value = $(event.target).inputmask("unmaskedvalue");
                if (value.length === 1 && value === "8") {
                    $this.inputmask("setvalue", "+7 ");
                    $this.focus();
                    $this.selectRange(3);
                }
            }, 100);
        }).addClass("mask-inited");

    }
}

$.fn.getCursorPosition = function() {
    var input = this.get(0);
    if (!input) return; // No (input) element found
    if ('selectionStart' in input) {
        // Standard-compliant browsers
        return input.selectionStart;
    } else if (document.selection) {
        // IE
        input.focus();
        var sel = document.selection.createRange();
        var selLen = document.selection.createRange().text.length;
        sel.moveStart('character', -input.value.length);
        return sel.text.length - selLen;
    }
};

$.fn.selectRange = function(start, end) {
    if(end === undefined) {
        end = start;
    }
    return this.each(function() {
        if('selectionStart' in this) {
            this.selectionStart = start;
            this.selectionEnd = end;
        } else if(this.setSelectionRange) {
            this.setSelectionRange(start, end);
        } else if(this.createTextRange) {
            var range = this.createTextRange();
            range.collapse(true);
            range.moveEnd('character', end);
            range.moveStart('character', start);
            range.select();
        }
    });
};



/*
* Form handlers
* */


function form_process_init() {

    $(document).on("reset", ".js-reset-form", function () {
        var $form = $(this);
        setTimeout(function () {
            $form.find(":input").trigger("change");
            $form.find(".js-checkbox input[type='checkbox'], .js-checkbox input[type='radio']").trigger("change-pseudo");
        }, 50);
    });

    $(document).on("submit.valid click perform-action", ".js-action", function(e){
        var $this = $(this);
        if ($this.is("form") && e.type != "submit") {
            return true;
        }
        e.preventDefault();
        // var url = $this.attr("href");
        // var method = "get";
        // var data = null;
        //
        // $this.find('.js-file-upload-hash').val(new Date().getTime());
        //
        // if ($this.is("form")) {
        //     url = $this.attr("action");
        //     if ($this.attr("method")) {
        //         method = $this.attr("method");
        //     }
        // }
        // if ($this.attr("data-action-url")) {
        //     url = $this.attr("data-action-url");
        // }
        // if ($this.attr("data-action-method")) {
        //     method = $this.attr("data-action-method");
        // }
        //
        // if ($this.is("form")) {
        //     data = $this.serialize();
        //
        //     if (method.toLowerCase() != 'get' && window.FormData !== undefined) {
        //         data = new FormData($this[0]);
        //     }
        //     $this.data('serialized', data);
        //     $this.data('serializedArray', $this.serializeArray());
        // }

        if ($this.find('.js-file-upload-start').length) {
            form_process_before_send($this);
            $this.find('.js-file-upload-start').trigger('click');
        }
        else {
            grecaptcha.ready(function () {
                grecaptcha.execute('6LfGda8nAAAAAINAuv20mntk7IjYIwiXsE0gCjzu', { action: 'contact' }).then(function (token) {
                    var recaptchaResponse = document.getElementById('recaptchaResponse');
                    recaptchaResponse.value = token;

                    var url = $this.attr("href");
                    var method = "get";
                    var data = null;

                    $this.find('.js-file-upload-hash').val(new Date().getTime());

                    if ($this.is("form")) {
                        url = $this.attr("action");
                        if ($this.attr("method")) {
                            method = $this.attr("method");
                        }
                    }
                    if ($this.attr("data-action-url")) {
                        url = $this.attr("data-action-url");
                    }
                    if ($this.attr("data-action-method")) {
                        method = $this.attr("data-action-method");
                    }

                    if ($this.is("form")) {
                        data = $this.serialize();

                        if (method.toLowerCase() != 'get' && window.FormData !== undefined) {
                            data = new FormData($this[0]);
                        }
                        $this.data('serialized', data);
                        $this.data('serializedArray', $this.serializeArray());
                    }

                    // Make the Ajax call here
                    $.ajax({
                        url: url,
                        type: method,
                        data: data,
                        dataType: 'json',
                        cache: false,
                        contentType: false,
                        processData: false,
                        beforeSend: function () {
                            form_process_before_send($this);
                        },
                        complete: function (response) {
                            form_process_complete($this, response);
                        },
                        success: function (response) {
                            form_process_errors_clear($this);
                            form_process_success($this, response);
                        },
                        error: function (jqXHR) {
                            form_process_errors_clear($this);
                            form_process_errors($this, jqXHR);
                        }
                    });
                });
            });
        }
    });

    $(document).on("after-action-success", ".js-action-reset-after", function(e, response){
        var is_success = form_response_is_success($(this), response);
        if (is_success) {
            $(this)[0].reset();
            $(this).find(":input").trigger("textfield-filled").first().trigger("check-form");
        }
    });

    $(document).on("change", ".js-submit-on-input-change :input", function(e){
        $(this).closest('form').trigger('submit');
    });
}

function form_process_before_send($this) {
    $this.find(":input").prop("disabled", true).closest(".textfield-wrapper").addClass("disabled");
    $this.find(".js-form-disable-on-submit").addClass("disabled");
    var $btn = $this.find(".loader-on-submit");
    if (window['loader_add']) {
        loader_add($btn);
    }
}

function form_process_complete($this, response) {
    $this.find(":input").not("[data-disabled]").prop("disabled", false).closest(".textfield-wrapper").removeClass("disabled");
    $this.find(".js-form-disable-on-submit").not("[data-disabled]").removeClass("disabled");
    $this.find(":password").val("");
    var $btn = $this.find(".loader-on-submit");
    if (window['loader_remove']) {
        loader_remove($btn);
    }
    $this.trigger("after-action-complete", response);
}


function form_response_is_success($this, response) {
    var response_success = $this.data('response-success');
    var is_success = true;
    if (response_success) {
        $.each(response_success, function(k, v) {
            if (response[k] !== v) {
                is_success = false;
                return false;
            }
        });
    }
    return is_success;
}

function form_process_success($this, response) {
    var is_success = form_response_is_success($this, response);
    var popup_success = $this.data('popup-success');
    if (is_success) {
        if (popup_success) {
            $.fancybox.close();
            $.fancybox.open({
                'src': popup_success,
                'type': 'ajax',
                'opts': $.fancybox.options_modal
            });
        }
        else if (response.popup) {
            if (response.text) {
                $.fancybox.close();
                $.fancybox.open(response.text, $.fancybox.options_modal);
            }
        }
        else {
            var $message = $this.find(".js-message");
            if (!$message.length) {
                $message = $this.find($this.data("message"));
            }
            if (!$message.length) {
                $message = $($this.data("message"));
            }
            if ($message.length) {
                $message.find(".js-message-container").html(response.text);
                bind_widgets($this);
                $message.addClass("active");
                $this.addClass("inactive");
                if ($message.offset().top < $(window).scrollTop()) {
                    goto_object($message, null);
                }
                if ($this.data("message-autoclose"))
                {
                    setTimeout(function(){
                        $message.removeClass("active");
                        $this.removeClass("inactive");
                    }, $this.data("message-autoclose"));
                }
            }
        }
    }
    else {
        var error_text;
        if (response.errors) {
            form_process_errors_show($this, response);
        }
        else if (response.text) {
            error_text = response.text;
        }
        else {
            error_text = 'Error occurs. Try again.';
        }
        if (error_text && $().fancybox) {
            $.fancybox.open('<div class="panel"><div class="panel__content">'+error_text+'</div></div>', $.fancybox.options_modal);
        }
    }
    $this.trigger("after-action-success", response);
}

function form_process_errors($this, jqXHR) {
    console.log(jqXHR.status, jqXHR.responseJSON);
    var error_text;
    if (jqXHR.status === 401) {
        error_text = 'Access denied.';
    }
    else if (jqXHR.status === 422) {
        form_process_errors_show($this, jqXHR.responseJSON);
    }
    else {
        error_text = 'Error occurs. Try again.';
    }
    if (error_text) {
        alert(error_text);
    }
    $this.trigger("after-action-error", jqXHR);
}

function form_process_errors_clear($this) {
    $this.find('.form-process-error').removeClass('error form-process-error');
    $this.find('.form__error--form-process-error').remove();
}

function form_process_errors_show($this, response) {
    var index = 0;
    form_process_errors_clear($this);
    $.each(response.errors, function(field_name, field_errors){
        $field = $this.find("[name='" + field_name + "']");
        $field.addClass("error form-process-error");
        if (!index) {
            setTimeout(function(){
                $field.trigger("focus");
            }, 100);
        }
        var $appendto = $field.closest(".js-form-error-place");
        if (!$appendto.length) {
            $appendto = $field.closest(".js-form-error-place-wrapper").find(".js-form-error-place");
        }
        if (!$appendto.length) {
            $appendto = $field.parent();
        }
        $appendto.find('.form__error').remove();
        if (!Array.isArray(field_errors)) {
            field_errors = [field_errors];
        }
        $.each(field_errors, function(error_index, error_text) {
            $appendto.append("<div id='"+field_name+"-error' class='form__error form__error--form-process-error'>" + error_text + "</div>");
        });
        index++;
    });
}



/*

 Form Validation

 */

function validate_init(context)
{
    if (!$.validator) return;

    if (!$("body").hasClass("validate-inited")) {

        $(document).on("reset", ".js-form-validate", function () {
            var $form = $(this);
            $form.find(".form__item, :input").removeClass("error");
            setTimeout(function () {
                $form.find(":input").trigger("change");
                $form.find(".js-checkbox input[type='checkbox'], .js-checkbox input[type='radio']").trigger("change-pseudo");
            }, 50);
        });

        $.extend($.validator.messages, {
            required: "Required field.",
            email: "Invalid E-mail.",
            uname: "Invalid name.",
            phone: "Uncompleted phone number.",
            phonecomplete: "Uncompleted phone number.",
            maskcomplete: "Fill this field completely.",
        });

        var lang = $('html').attr('lang');
        switch (lang) {
            case 'ru':
                $.extend( $.validator.messages, {
                    required: "Обязательное поле.",
                    email: "Некорректный E-mail.",
                    uname: "Некорректно заполненное имя.",
                    phone: "Неполный номер телефона.",
                    phonecomplete: "Неполный номер телефона.",
                    maskcomplete: "Заполните поле полностью.",
                } );
                break;
            default:
        }

        $.validator.addMethod("email", function( value, element ) {
            return this.optional( element ) || /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test( value ); // /^[a-zA-Z\-\._]+@[a-z0-9\-]+(\.[a-z0-9\-]+)*\.[a-z]+$/i
        });

        $.validator.addMethod("uname", function(value, element) {
            return this.optional(element) || /^[a-z\u00C0-\u01FF\u0400-\u04FF'][ a-z\u00C0-\u01FF\u0400-\u04FF'\-]*[a-z\u00C0-\u01FF\u0400-\u04FF]$/i.test( value ); // european and cyrillic names
        });

        $.validator.addMethod("phone", function(value, element) {
            return this.optional(element) || (value.replace(/\D/, "").length >= 7);
        });

        $.validator.addMethod("phonecomplete", function(value, element) {
            return this.optional(element) || (value.replace(/\D/, "").length >= 7 && $(element).inputmask('isComplete'));
        });

        $.validator.addMethod("maskcomplete", function(value, element) {
            return this.optional(element) || $(element).inputmask('isComplete');
        });

        $.each($.validator.methods, function (key, value) {
            $.validator.methods[key] = function () {
                if(arguments.length > 0) {
                    arguments[0] = $.trim(arguments[0]);
                }
                return value.apply(this, arguments);
            };
        });

        $(document).on("keyup blur change check-form", ".form-disabled-until-valid :input", function () {
            var $form = $(this).closest(".form-disabled-until-valid");
            var result = $form.validate().checkForm();
            var $if_filled = $form.find('.form-disabled-until-valid-check-filled');
            var is_filled = $if_filled.filter('.filled').length == $if_filled.length;
            if ($if_filled.length) {
                result = result && is_filled;
            }
            var $button = $form.find(".disabled-until-valid");
            $button.prop('disabled', !result);
        });

        $(document).on("change change-checkbox-valid", "input[type='checkbox'], input[type='radio']", function () {
            var $form = $(this).closest("form");
            var validator = $form.data("validator");
            if (validator) $(this).valid();
        });

        $("body").addClass("validate-inited");
    }

    var $forms = context?$('.js-form-validate', context):$('.js-form-validate');
    $forms = $forms.not(".js-form-validate-inited");
    $forms.each(function(){
        $(this).validate({
            onkeyup: false,
            normalizer: function( value ) {
                return $.trim( value );
            },
            errorClass: 'form__error',
            validClass: 'valid',
            errorElement: 'div',
            highlight: function(element, errorClass, validClass) {
                $(element).addClass('error').removeClass('valid');
            },
            unhighlight: function(element, errorClass, validClass) {
                $(element).addClass('valid').removeClass('error');
            },
            errorPlacement: function(error, element) {
                var $appendto = $(element).closest(".js-form-error-place");
                if (!$appendto.length) {
                    $appendto = $(element).closest(".js-form-error-place-wrapper").find(".js-form-error-place");
                }
                $appendto.append(error);
            },
            submitHandler: function(form, e) {
                $(form).trigger("submit.valid");
            }
        });

        $(this).addClass("js-form-validate-inited")
    });

    $(".form-disabled-until-valid-onload").find(":input").first().trigger("check-form");

}